import { AuthService } from "../services";
import { ActionTypes } from "./ActionTypes";

export function expireToken() {
  return function(dispatch) {
    AuthService.clearToken();
    dispatch({ type: ActionTypes.LOGOUT });
  };
}
